import { Slideout, Typography } from "@ann/web-components";
import ChatHistory from "../chatHistory/itemChat";
// Get today's date in MM/DD/YY format
const today = new Date();
const todayFormatted = `${(today.getMonth() + 1).toString().padStart(2, '0')}/${today.getDate().toString().padStart(2, '0')}/${today.getFullYear().toString().slice(-2)}`;

const chatHistory = [
    {
        id: 1,
        type: "receive",
        time: "9:30 AM",
        date: "03/13/24",
        body: "This is a reminder that your vehicle's warranty will expire in 30 days. Please contact us if you have any questions or want to extend your coverage. Best regards, Sammy"
    },
    {
        id: 2,
        type: "send",
        time: "9:45 AM",
        date: "03/13/24",
        body: "Hi Sammy, yes I got the notice. Thanks for the reminder. Could you tell me what repairs are covered under the warranty?"
    },
    {
        id: 3,
        type: "receive",
        time: "11:30 AM",
        date: "03/13/24",
        body: "Hi Mike, Sure! Your warranty covers most parts and labor related to the engine, transmission, and electrical systems for up to 5 years or 60,000 miles. If you want, I can send you a detailed list."
    },
    {
        id: 4,
        type: "send",
        time: "11:30 AM",
        date: "03/13/24",
        body: "That would be great, thanks. Also, how can I schedule a service appointment?"
    },
    {
        id: 5,
        type: "receive",
        time: "11:35 AM",
        date: "03/13/24",
        body: "When would you like to come in?"
    },
    {
        id: 6,
        type: "send",
        time: "1:30 PM",
        date: "03/14/24",
        body: "Next Friday morning works for me."
    },
    {
        id: 7,
        type: "receive",
        time: "1:30 PM",
        date: "03/14/24",
        body: "When would you like to come in? 7:30 AM"
    },
    {
        id: 8,
        type: "send",
        time: "9:30 AM",
        date: todayFormatted,
        body: "Hi Sammy, Thanks for the reminder. I am a bit busy next week. Can we schedule something for the following week? Regards, Mike"
    },
    {
        id: 9,
        type: "receive",
        time: "9:45 AM",
        date: todayFormatted,
        body: "Sure! How about next Wednesday at 10 AM?"
    },
    {
        id: 10,
        type: "send",
        time: "10:00 AM",
        date: todayFormatted,
        body: "Perfect! See you then."
    }
]

const SMSSlideOut = ({ open, onClose, sms }) => {
    const title = sms?.type || "SMS conversation";
    return (
        <Slideout
            open={open}
            onClose={onClose}
        >
            <Slideout.HeaderActions>
                {/* Temporary disabled for Version 1 
                <Button
                    type='secondary'
                    icon='openInFull'
                    size='medium'
                    pill={true}
                /> */}
            </Slideout.HeaderActions>
            <Slideout.Header>
                <Typography
                    category="title"
                    size="large"
                    weight="bold"
                    maxCharacters={40}
                    titleOnHover
                >
                    {title}
                </Typography>
            </Slideout.Header>
            <Slideout.Content>
                <ChatHistory chatHistory={chatHistory} />
            </Slideout.Content>
        </Slideout>
    );
}

export default SMSSlideOut;